module.exports = __webpack_public_path__ + "img/expl-selfie-1.61c920a3.svg";